module.exports = __webpack_public_path__ + "img/cx_teste_hemoglobina.311046d1.webp";